'use strict';

export default {
  formList: {
    columns: {
      formName: 'Form Name',
      submission: 'Submission(s)',
      status: 'Status',
      lastUpdate: 'Last Update',
      editedBy: 'Edited By',
      active: 'Active',
      pending: 'Pending',
      complete: 'Complete',
      draft: 'Draft',
      actions: 'Actions',
      archived: 'Archived',
    },
    buttons: {
      editForm: 'Edit Form',
      preview: 'Preview form',
      view: 'View/Edit',
      submissions: 'View submissions',
      addItem: '+ Add Item',
      createForm: 'Create Form',
      returnToForms: 'Return to forms',
      delete: 'Delete form',
      cloneForm: 'Clone',
      archive: 'Archive',
      unarchive: 'Unarchive',
    },
    deleteModal: {
      deleteModalHeader: 'Attention!',
      deleteConfirmation: 'Are you sure you want to delete this form?',
    },
    archiveModal: {
      archiveModalHeader: 'Archive Form',
      archiveConfirmation: 'Are you sure you want to archive this form?',
    },
    createNewFormModal: {
      header: 'Create New Form',
      formName: 'Form Name',
      template: 'Template',
      emptyFormName: 'Please give the form a valid name',
      emptyLanguage: 'Please choose at least one language',
    },
    cloneFormModal: {
      header: 'Clone Form',
      formName: 'Form Name',
      emptyFormName: 'Please give the form a valid name',
      copy: 'Copy',
    },
    resendEmailModal: {
      sendSubmissionEmail: 'Resend Submission Email',
      email: 'Email',
      send: 'Send',
    },
    submission: {
      currentSubmission: 'Current Submission: ',
      formId: 'Form id: ',
      submissionId: 'Submission id: ',
      sentDate: 'Sent Date: ',
      paymentStatus: 'Payment Status: ',
      edit: 'Edit',
      save: 'Save',
      cancel: 'Cancel',
      summary: 'Summary',
      noFields: 'No Fields',
      submit: 'Submit',
      updateSuccess: 'Submission Successfully Updated',
      updateError: 'Submission Failed to Update',
      deleteSuccess: 'Submission deleted successfully',
      modalTitle: 'Delete Submission',
      modalMessage: 'Are you sure you want to delete this submission ?',
      noSubmissions: 'There are no submissions yet for this form',
      view: 'View/Edit',
      formName: 'Form Name:',
      refund: 'Refund',
      refundError: 'Error while processing the refund',
      refundSuccess: 'Refund successful',
      refundAmount: 'Refund amount',
      refundAmountError: 'Refund amount higher than total payment',
      refundStripeFees: 'Refund Stripe fees',
      confirm: 'Confirm',
      paymentTotal: 'Total payment',
      chooseRefundAmount: 'Choose refund amount',
      cancelPayment: 'Cancel payment',
      cancelSuccess: 'Payment successfully canceled',
      cancelError: 'Error while trying to cancel payment',
      otherMethod: 'Autre méthode de paiement',
      total: 'Total',
      discount: 'Rabais',
    },
    refundHeaders: {
      paymentIntentId: 'ID de paiement',
      paymentTotal: 'Paiement total',
      stripeFees: 'Frais Stripe',
      status: 'Statut',
    },
    forms: {
      noForms: 'There are no forms yet for this organization',
    },
    templates: {
      blank: 'Blank',
      contact: 'Contact us',
    },
  },
};
